module.exports = __webpack_public_path__ + "img/erp.e508967b.png";